import {OPEN_CLOSE_MODAL} from '../constants/actionTypes';
import defaultStoreValues from '../constants/defaultStoreValues';

export default (state, action) => {
    switch (action.type) {
        case OPEN_CLOSE_MODAL:
            let newModalOpenState = (action.notificationText && state.isModalOpen) || !state.isModalOpen;
            let newOpenModalType = newModalOpenState
                ? action.modalType
                : defaultStoreValues.openModalType;
            let newNotificationType = newModalOpenState
                ? action.notificationType
                : defaultStoreValues.notificationType;
            let newNotificationTitle = newModalOpenState
                ? action.notificationTitle
                : defaultStoreValues.notificationTitle;
            let newNotificationText = newModalOpenState
                ? action.notificationText
                : defaultStoreValues.notificationText;
            let newIsNotificationLocalizable = newModalOpenState
                ? action.isNotificationLocalizable
                : defaultStoreValues.isNotificationLocalizable;
            let newNotificationWildCards = newModalOpenState
                ? action.notificationWildCards
                : defaultStoreValues.notificationWildCards
            let newIsNotificationDismissible = newModalOpenState
                ? action.isNotificationDismissible
                : defaultStoreValues.isNotificationDismissible
            let newCallBackFunction = newModalOpenState
                ? action.callBackFunction
                : defaultStoreValues.callBackFunction
            let newCallBackFunctionType = newModalOpenState
                ? action.callBackFunctionType
                : defaultStoreValues.callBackFunctionType

            return {
                ...state,
                isModalOpen: newModalOpenState,
                openModalType: newOpenModalType,
                notificationType: newNotificationType,
                notificationTitle: newNotificationTitle,
                notificationText: newNotificationText,
                isNotificationLocalizable: newIsNotificationLocalizable,
                notificationWildCards: newNotificationWildCards,
                isNotificationDismissible: newIsNotificationDismissible,
                callBackFunction: newCallBackFunction,
                callBackFunctionType: newCallBackFunctionType
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js